window.HomeHeroBanner = (randomId) => {
  return {
    swiper: null,
    init() {
      setTimeout(() => {
        this.swiper = new Swiper("#swiper-" + randomId, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoplay: {
            delay: 3000,
          },
          grabCursor: true,
          a11y: true,
        });
      }, 0);
    },
  };
};
